module.exports = __webpack_public_path__ + "static/media/shop-business-hover.03f5b269.svg";